import React, { Component } from 'react'
import { connect } from 'react-redux'

import TextField from 'material-ui/TextField'
import Divider from 'material-ui/Divider'

import StatusSelect from '../dashboard/propertyForm/StatusSelect'
import Facts from './Facts'
import Events from './events'
import PropertyAvatar from '../dashboard/propertyForm/PropertyAvatar'
import StatusIcons from './StatusIcons'

import { propertyAlias } from 'utils/propertyAlias'
import { propertyCors } from 'utils/propertyCors'
import dataActions from 'actions/dataActions'

import { doc, dirtyRead } from 'selectors/common'

let select = dirtyRead(
	(state, props) => ({
		property: doc(state, props.propertyID)
	})
)

export class LeftSide extends Component{
	render(){
		let { props } = this
		let address = props.property.address || ""
		return(
			<div
				key={props.property.alias}
				className="left-side"
				style={{
					 width: (this.props.colspan>1)?"50%":"100%"
   				   , overflowY: "hidden"
				   , overflowX: "hidden"
					 , paddingBottom:"10px"
					 , paddingRight:"5px"
				}}
			>
			<div style={{width: "100%", padding:"0 30px 10px 20px", boxShadow:props.expanded?"0px 2px 1px rgba(0,0,0,0.3)":"0px 1px 1px rgba(0,0,0,0.3)", background:"white", marginTop:"-10px"}}>
				<PropertyAvatar objectID={props.propertyID} propertyID={props.propertyID}/>
				<div style={{width: "65%", float: "right", paddingTop:"20px"}}>

					<div>
						<TextField
						    hintText = "Enter address"
						    hintStyle={{fontStyle: "italic", fontSize: "16px", top:"13px"}}
						    underlineStyle={{
						        borderBottom: "0px solid #b0bec4"
						    }}
						    multiLine = {false}
						    underlineDisabledStyle={{borderBottom: "0px solid"}}
						    style={{
						        width: "100%"
						      , position: "relative"
						      , height: "45px"
						      , color: "#293038"
						    }}
						    inputStyle={{
						        fontSize: "16px"
						      , fontWeight: "bold"
						      , color: "#293038"
						    }}
						    defaultValue={address}
						    onBlur={(evt) =>{
						        //let cors = propertyCors(evt.target.value)
						        props.STAGE({
						            _id: props.propertyID
						            , address: evt.target.value.replace(/[\r\n\t\v]/g, " ")
						            , alias: props.property.alias || propertyAlias(evt.target.value)
						            , cors: {}
						        })
						    }}
						/>
						<TextField
							hintText = {(address)?"Enter address":"Waiting for address input"}
							hintStyle={{fontStyle: "italic", fontSize: "16px", top:"13px"}}
							underlineStyle={{
								borderBottom: "0px solid #b0bec4"
							}}
							multiLine = {false}
							underlineDisabledStyle={{borderBottom: "0px solid"}}
							style={{
								marginTop: "-10px"
							  , position: "relative"
							  , paddingLeft: "0"
							  , height: "45px"
							  , color: "black"
							  , width: "100%"
							}}
							inputStyle={{
								fontSize: "16px"
							  , fontWeight: "bold"
							  , color: "black"
							}}
							defaultValue={props.property.alias}
							onBlur={(evt) =>{
								props.STAGE({
									_id: props.propertyID
								  , alias: evt.target.value
								})
							}}
						/>
					</div>

				</div>
				<div style={{clear:"both"}}></div>
			</div>
				<Facts propertyID={this.props.propertyID} />

			</div>
		)
	}
}

export default connect(select, dataActions)(LeftSide)



// WEBPACK FOOTER //
// ./src/routes/landlord/propertyForm/LeftSide.js